import React from 'react';

import './Settings.css';
import './SettingsRightSide.css'
import './SettingsLeftSide.css'
import Background from './Background'
import Quote from './Quote'
import General from './General'
import User from './User'

class Settings extends React.Component {
		constructor() {
		super()
		this.state = {
			toggleGeneral: true,
			toggleBackgrounds: false,
			toggleQuotes: false,
		}

		this.handleMenuSelection = this.handleMenuSelection.bind(this);
	}


	handleMenuSelection(e) {
		let target = e.target.id
		document.querySelector(`.${target}-container`).classList.add('show');	
	}

	render() {
		return (
			<div id='settings' className='settings-container' onDoubleClick={this.props.dragWidget}>
				<div className='settings-flex'>
					<div id='settings' className='settings-left-side'>
						<nav className='options-wrapper' >
							<button id='general' className='options' >General</button>
							<button  id='backgrounds' className='options' >Backgrounds</button>
							<button id='quotes' className='options' >Quotes</button>
						</nav>
						<User />
					</div>
					<div id='settings' className='settings-right-side'>
						<General />
						<Background />
						<Quote />
					</div>
				</div>
			</div>
		)
	}
}

export default Settings;